module.exports = __webpack_public_path__ + "img/testbg.ffe5613d.png";